import { BusinessLegalStructure } from './business-legal-structure.model';
export class EzSchedule {
  public ownersSchedule1: BusinessLegalStructure[];
  public affiliatesSchedule2: BusinessLegalStructure[];
  public affiliatesSchedule3: BusinessLegalStructure[];
    constructor() { }
}